__turbopack_context__.v({
  "backgroundLayer": "kdKZJW_backgroundLayer",
  "blurredCard": "kdKZJW_blurredCard",
  "buttons": "kdKZJW_buttons",
  "caption": "kdKZJW_caption" + " " + __turbopack_context__.i(263274)["bannerCaption"],
  "content": "kdKZJW_content",
  "contentColumn": "kdKZJW_contentColumn",
  "foregroundImageWrapper": "kdKZJW_foregroundImageWrapper",
  "note": "kdKZJW_note",
  "sectionContent": "kdKZJW_sectionContent",
  "subtitle": "kdKZJW_subtitle" + " " + __turbopack_context__.i(263274)["bannerSubtitle"],
  "textStack": "kdKZJW_textStack",
  "title": "kdKZJW_title" + " " + __turbopack_context__.i(263274)["bannerTitle"],
});
